var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M21.49,7.13l-9-5a1,1,0,0,0-1,0l-9,5A1,1,0,0,0,2,8V21a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V15h4v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V8A1,1,0,0,0,21.49,7.13Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }